import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Shield, Scale, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';
import NavigationMenu from '../components/NavigationMenu';

const CopyrightPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50">
      <NavigationMenu />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button
          onClick={() => navigate(-1)}
          variant="ghost"
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('copyright.back')}
        </Button>

        <div className="mb-8">
          <h1 className="text-4xl font-bold text-amber-900 mb-2">
            <Scale className="w-10 h-10 inline-block mr-3" />
            {t('copyright.title')}
          </h1>
          <p className="text-gray-600">© {currentYear} mAI Recipes. {t('footer.copyright')}</p>
        </div>

        <div className="space-y-6">
          <Card className="p-6 border-2 border-amber-100">
            <h2 className="text-2xl font-semibold text-amber-900 mb-4 flex items-center gap-2">
              <Shield className="w-6 h-6" />
              {t('copyright.intellectualProperty')}
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>{t('copyright.intellectualPropertyText')}</p>
              <p>{t('copyright.intellectualPropertyText2')}</p>
            </div>
          </Card>

          <Card className="p-6 border-2 border-amber-100">
            <h2 className="text-2xl font-semibold text-amber-900 mb-4 flex items-center gap-2">
              <FileText className="w-6 h-6" />
              {t('copyright.permittedUse')}
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>{t('copyright.youCan')}</strong></p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                {t('copyright.youCanList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>

              <p className="mt-6"><strong>{t('copyright.youCannot')}</strong></p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                {t('copyright.youCannotList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </Card>

          <Card className="p-6 border-2 border-amber-100">
            <h2 className="text-2xl font-semibold text-amber-900 mb-4">
              {t('copyright.aiContent')}
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>{t('copyright.aiContentText')}</p>
              <p>{t('copyright.aiContentText2')}</p>
            </div>
          </Card>

          <Card className="p-6 border-2 border-amber-100">
            <h2 className="text-2xl font-semibold text-amber-900 mb-4">
              {t('copyright.trademarks')}
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>{t('copyright.trademarksText')}</p>
            </div>
          </Card>

          <Card className="p-6 border-2 border-orange-100 bg-orange-50">
            <h2 className="text-2xl font-semibold text-orange-900 mb-4">
              {t('copyright.legalContact')}
            </h2>
            <div className="space-y-2 text-gray-700">
              <p>{t('copyright.legalContactText')}</p>
              <p className="font-semibold">
                📧 support@mai-recipes.com
              </p>
            </div>
          </Card>

          <div className="text-center text-sm text-gray-500 mt-8">
            <p>{t('copyright.lastUpdated')} {new Date().toLocaleDateString(i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyrightPage;
